import React from 'react';
import { useSelector } from 'react-redux';
import { ActivitiesMessagingClient } from 'core/messaging/ActivitiesMessagingClient';
import { ConsentBanner } from '@agoda/agoda-consent-banner';
import { selectPageConfigFromBootstrap, selectPrerenderStateFromBootstrap } from 'store/slice/bootstrap';
import { trackElementEvent } from 'core/messaging/analytics/analytics';

const ConsentBannerComponent: React.FC<{}> = (props) => {
    const pageConfig = useSelector(selectPageConfigFromBootstrap);
    const isPrerender = useSelector(selectPrerenderStateFromBootstrap);

    if (isPrerender) return null;

    const sendAnalyticData = (elementName: string, actionType: string) => {
        trackElementEvent({ action_element_name: elementName, action_type: actionType, event_version: 1 }, {});
    };

    return (
        <ConsentBanner
            origin={pageConfig.origin ?? ''}
            cid={pageConfig.cid ?? -1}
            pageTypeId={pageConfig.pageTypeId ?? 0}
            msgClient={ActivitiesMessagingClient}
            analyticCallback={sendAnalyticData}
            langId={pageConfig.languageId.toString()}
            langLocale={pageConfig.cultureInfoName}
        />
    );
};
ConsentBannerComponent.displayName = 'ConsentBannerComponent';

export { ConsentBannerComponent };
